import React, { Component } from 'react'
import LayoutWrapper from '../../component/LayoutWrapper/'
import './OrderHistory.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { historyOrderList, doOrderHistoryListRes } from '../../action/OrderHistoryListAction'
// import { label } from 'react-konva';
import Footer from '../../component/Footer/Footer';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class OrderHistory extends Component {
    constructor() {
        super();
        this.state = {
            OrderHistoryData: [],
            orderUdateData: [],
            // isLoader: false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const data = {
            user_id: localStorage.getItem('userId')
        }
        this.setState({
            // isLoader: true,
        })
        this.props.historyOrderList(data)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doOrderHistoryListRes && nextProps.doOrderHistoryListRes.user) {
            if (nextProps.doOrderHistoryListRes.user && nextProps.doOrderHistoryListRes.user.OrderHistoryListRes) {
                if (nextProps.doOrderHistoryListRes.user.OrderHistoryListRes && nextProps.doOrderHistoryListRes.user.OrderHistoryListRes.result === true) {
                    this.setState({
                        OrderHistoryData: nextProps.doOrderHistoryListRes.user.OrderHistoryListRes.order_history,
                        // isLoader: true,
                    })
                } else {
                    this.setState({
                        // isLoader: false,
                    })
                }
            }
        }
    }

    productImage(data) {
        // {
        //     data.children && data.children.map((imgItem, i) =>(
        //         <div key={i}><img src={imgItem.data.photo} alt="" width="50px" /></div>
        //     ))
        // }   
        // return (


        // )
    }

    OrderDeatails = (item) => {
        this.props.history.push('/order-details', {
            orderData: item
        })
    }
    orderTracking = (item) => {
        this.props.history.push('/order-tracking', {
            orderData: item
        })
    }

    logOut = () => {
        localStorage.clear();
        window.location.href = '/';
    }

    render() {
        // const spinner = <span><img src={loaderImg} alt="" /></span>;
        return (
            // <div className="page-wrapper">
            <React.Fragment>
                <LayoutWrapper />
                <div>
                    <main className="main main-container">

                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/"><i className="icon-home"></i></a></li>
                                    <li className="breadcrumb-item"><a href="/">Order History</a></li>
                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9 order-lg-last dashboard-content">
                                    <h2>Order History</h2>
                                    <div className="cardHeight">
                                        {
                                            this.state.OrderHistoryData && this.state.OrderHistoryData.map((item, i) => (
                                                <div className="card bdr-redys" key={i}>
                                                    <div className="card-body body-height">
                                                        <div className="container">

                                                            <div className="row col-size">
                                                                <div className="col col-size">
                                                                    <label htmlFor="order-id" className="odr-id">Order Id</label>
                                                                    <div id="order-id" className="fnt-odr">{item.order_id}</div>
                                                                </div>
                                                                <div className="col col-size">
                                                                    <label htmlFor="order-item" className="odr-id">Order Item</label>
                                                                    <div id="order-item" className="fnt-odr">{item.product_details.length} Item </div>
                                                                </div>
                                                                {
                                                                    item.total_price === '' ?
                                                                        <div className="col col-size">
                                                                            <label htmlFor="total-Price">Total Price</label>
                                                                            <div id="total-Price" className="totalPrice">
                                                                                <i className="fa fa-rupee-sign" aria-hidden="true"></i> 0.00
                                                                            </div>
                                                                        </div>
                                                                        : <div className="col col-size">
                                                                            <label htmlFor="total-Price" className="totl">Total Price</label>
                                                                            <div id="total-Price" className="totalPrice"> <i className="fa fa-rupee-sign" aria-hidden="true"></i> {parseFloat(item.total_price).toFixed(2)}</div>
                                                                        </div>
                                                                }
                                                                <div className="col col-size">
                                                                    <label htmlFor="status" className="status-id">Status</label>
                                                                    {parseInt(item.status) === 0 &&
                                                                        <div className="btn-pend order-fnt col-md-8 status-btn">Pending</div>}
                                                                    {parseInt(item.status) === 1 &&
                                                                        <div className="btn-clr-warning order-fnt col-md-8 status-btn">Confirm</div>}
                                                                    {parseInt(item.status) === 2 &&
                                                                        <div className="btn-clr-info order-fnt col-md-8 status-btn">Processing</div>}
                                                                    {parseInt(item.status) === 3 &&
                                                                        <div className="btn-clr-primary order-fnt col-md-8">Shipped</div>}
                                                                    {parseInt(item.status) === 4 &&
                                                                        <div className="btn-clr-success order-fnt col-md-8">Delivered</div>}
                                                                    {parseInt(item.status) === 5 &&
                                                                        <div className="btn-clr-success order-fnt col-md-8">In Transit</div>}
                                                                    {parseInt(item.status) === 6 &&
                                                                        <div className="btn-clr-success order-fnt col-md-8">Return</div>}
                                                                </div>
                                                                <div className="col col-span mar-btn col-size ">
                                                                    <span className="btn-1 mt-btn" onClick={() => this.OrderDeatails(item)} > Details </span>
                                                                </div>
                                                                {
                                                                    parseInt(item.status) === 3 &&

                                                                    <div className="col col-span col-size">
                                                                        <span className="order-tracker" onClick={() => this.orderTracking(item)}> Order Tracking </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <aside className="sidebar col-lg-3">
                                    <div className="widget widget-dashboard">
                                        <h3 className="widget-title">My Account</h3>

                                        <ul className="list">
                                            <li><a href="/profile-update">Account Details</a></li>
                                            <li>
                                                <a href="/my-wallet">My Wallet</a>
                                            </li>
                                            <li>
                                                <a href="/address-info">Address Info</a>
                                            </li>
                                            <li><a href="/change-password">Change-Password</a></li>
                                            <li className="active"><a href="/order-history">My Order</a></li>
                                            <li><a href="/corporate-order-history">Corporate Order</a></li>
                                            <li><span className="logoutLi" onClick={() => this.logOut()}>Logout</span></li>
                                        </ul>
                                    </div>
                                    {/* End .widget */}
                                </aside>
                                {/* End .col-lg-3 */}
                            </div>
                        </div>

                    </main>
                </div>

                <Footer />
            </React.Fragment>

        )
    }
}

OrderHistory.propTypes = {
    doOrderHistoryListRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doOrderHistoryListRes: doOrderHistoryListRes,
});

function mapDispatchToProps(dispatch) {
    return {
        historyOrderList: (data) => dispatch(historyOrderList(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(OrderHistory)
